import { Component, Input, Output, EventEmitter } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { FormGroup } from '@angular/forms';

declare var $;
@Component({
  selector: 'app-email',
  templateUrl: './email.component.html'
})
export class EmailComponent {
  txtEmail: string;
  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup;
  @Input() iconColor = '#2bcdb5';
  @Input() textColor = '#4d4d4d';
  @Output() emailValid = new EventEmitter<boolean>();
  @Output() emailClicked = new EventEmitter();

  isValidEmail: boolean;
  isEmpty: boolean;

  constructor() {
    this.isValidEmail = true;
    this.isEmpty = false;
  }

  checkEmailValid() {
    if (!this.form.controls[this.question.key].valid
      && (this.form.controls[this.question.key].errors !== null
        && this.form.controls[this.question.key].errors['email'] !== undefined)) {
      this.isValidEmail = false;
    } else {
      this.isValidEmail = true;
    }
  }

  checkRequired() {
    if (!this.form.controls[this.question.key].valid
      && (this.form.controls[this.question.key].errors !== null
        && this.form.controls[this.question.key].errors['required'] !== undefined)) {
      this.isEmpty = true;
    } else {
      this.isEmpty = false;
    }
  }

  checkValid() {
    this.checkEmailValid();
    this.checkRequired();

    this.emailValid.emit(this.isValidEmail);
  }

  resetValid() {
    this.isValidEmail = true;
    this.isEmpty = false;
  }

  handleKeyPress(event) {
    if (event.keyCode === 13) {
      $('#app-email').blur();
      this.emailClicked.emit('focusout');
    }
  }

  handleEmailClicked() {
    this.emailClicked.emit('focusin');
  }

  handleFocusout() {
    $('#app-email').blur();
    this.emailClicked.emit('focusout');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/email/email.component.ts